<ng-container *ngIf="clientService.client?.banner && clientService.client?.logo">
  <div id="banner_div" class="top-container" [class.no-padding]="hasHeader"
       [style.background-image]="'url(' + clientService.client.banner.path + ')'"
       [style.height]="environment.desktop ? '400px' : '25%'">
    <div style="height: 100%; justify-content: center; align-items: center;display: flex;">
        <img [src]="clientService.client.logo.path" alt="Logo" class="logo">
    </div>
  </div>
</ng-container>
